import type { Quality } from '../core/event-bus';

export const SAVE_KEY = 'lcca:save';
export const SAVE_VERSION = 1;
export const MAX_LIST = 200;
export const MAX_NAME = 24;

export interface Settings {
  muted: boolean;
  ambienceVolume: number;
  sfxVolume: number;
  vibration: boolean;
  quality: Quality;
  tutorialDone: boolean;
}

export interface Stats {
  visits: number;
  lastVisitDate: string;
  incenseCount: number;
  bellCount: number;
  chantCount: number;
  bestTamAn: number;
  bowCount: number;
}

export interface PrayerEntry {
  id: string;
  text: string;
  kind: 'silk' | 'lantern';
  createdAt: number;
}

export interface FortuneEntry {
  id: string;
  fortuneId: number;
  topic: string;
  confirmedByKeo: boolean;
  createdAt: number;
}

export interface KeoEntry {
  id: string;
  question?: string;
  result: 'thanh' | 'tieu' | 'am';
  createdAt: number;
}

export interface SaveData {
  version: 1;
  profile: { name: string; createdAt: number };
  settings: Settings;
  stats: Stats;
  prayers: PrayerEntry[];
  fortunes: FortuneEntry[];
  keoResults: KeoEntry[];
}

export function createDefaultSave(now: number): SaveData {
  return {
    version: 1,
    profile: { name: '', createdAt: now },
    settings: {
      muted: false,
      ambienceVolume: 0.8,
      sfxVolume: 0.9,
      vibration: true,
      quality: 'auto',
      tutorialDone: false,
    },
    stats: {
      visits: 0,
      lastVisitDate: '',
      incenseCount: 0,
      bellCount: 0,
      chantCount: 0,
      bestTamAn: 0,
      bowCount: 0,
    },
    prayers: [],
    fortunes: [],
    keoResults: [],
  };
}
